import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { padStart } from 'lodash';

dayjs.extend(utc);
dayjs.extend(timezone);

export function getPtTimeZoneDate(inputDate: string) {
  if (inputDate)
    return dayjs(inputDate).tz('America/Los_Angeles').format('MM/DD/YYYY');
}

export function getPtTimeIn24hr(inputTime: string) {
  if (inputTime) {
    const formattedDate = dayjs(inputTime)
      .tz('America/Los_Angeles')
      .format('MM/DD/YYYY h:mm:ss A');
    const d1: any = new Date(formattedDate);
    const timeIn24Hr =
      padStart(d1.getHours(), 2, '0') +
      ':' +
      padStart(d1.getMinutes(), 2, '0') +
      ':' +
      padStart(d1.getSeconds(), 2, '0');
    return timeIn24Hr + ' ' + 'PT';
  }
}

export const timezoneOffsetMap: { [key: string]: string } = {
  JT: 'Asia/Tokyo',
  ET: 'America/New_York',
  PT: 'America/Los_Angeles',
  CT: 'America/Chicago',
  IST: 'Asia/Kolkata',
  HT: 'Pacific/Honolulu',
  MT: 'America/Denver',
  AZ: 'America/Phoenix',
  AT: 'America/Anchorage',
  GMT: 'Etc/GMT',
  'Arabia Standard Time': 'Asia/Riyadh',
};

export function getTimezoneFromAbbreviation(abbreviation: string): string {
  return timezoneOffsetMap[abbreviation] || '';
}
